'use es6';

import { isLogicGroup } from '../filterQueryFormat/logic/LogicGroup';
import EmailOpened from '../filterQueryFormat/operator/EmailOpened';
import EmailOpenedButLinkNotClicked from '../filterQueryFormat/operator/EmailOpenedButLinkNotClicked';
import EmailOpenedButNotReplied from '../filterQueryFormat/operator/EmailOpenedButNotReplied';
import EmailReceivedButNotOpened from '../filterQueryFormat/operator/EmailReceivedButNotOpened';
import { isOperator } from '../filterQueryFormat/operator/Operator';
const AFFECTED_CONTACT_PROPERTIES = ['hs_sales_email_last_opened', 'hs_email_open', 'hs_last_sales_activity_timestamp', 'hs_email_sends_since_last_engagement', 'hs_email_first_open_date', 'hs_email_last_open_date'];
const AFFECTED_MARKETING_EMAIL_OPERATORS = [EmailOpened, EmailOpenedButLinkNotClicked, EmailOpenedButNotReplied, EmailReceivedButNotOpened];
const fieldContainsAffectedContactProperty = field => AFFECTED_CONTACT_PROPERTIES.some(property => field.name.includes(property));
export const operatorIsMarketingEmailOpenOperator = operator => AFFECTED_MARKETING_EMAIL_OPERATORS.some(affectedOperator => operator instanceof affectedOperator);
export const isOperatorAffectedByEmailPrivacy = operator => {
  if (!isOperator(operator)) {
    return false;
  }
  return fieldContainsAffectedContactProperty(operator.field) || operatorIsMarketingEmailOpenOperator(operator);
};
export const isLogicGroupAffectedByEmailPrivacy = logicGroup => {
  if (!isLogicGroup(logicGroup)) {
    return false;
  }
  return Boolean(logicGroup.conditions.find(condition => isLogicGroup(condition) ? isLogicGroupAffectedByEmailPrivacy(condition) : isOperatorAffectedByEmailPrivacy(condition)));
};